import {post} from '@/utils/request';

//获取table
export async function getList(params) {
    return post('/role/getList', params, true)
}